import {Separator} from 'platform/components';
import {Box, CSSDimension, Integer, Show, ValueByDevice, VStack} from 'platform/foundation';

import {forwardRef} from 'react';

import {ArticleFolderTree} from '@dms/shared';
import {DataGridTreeFolderHandle} from '@dms/shared-aftersales';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface ExternalFilterWithFolderTreeProps extends RequiredTestIdProps {
  externalFilterId: string;
  width?: CSSDimension | Integer | ValueByDevice<CSSDimension | Integer>;
  // Fills the side panel tile of DataGridTileLayout: own padding and separators across the whole
  // tile. The tile sets the width then.
  isPanel?: boolean;
}

export const ExternalFilterWithFolderTree = forwardRef<
  DataGridTreeFolderHandle,
  ExternalFilterWithFolderTreeProps
>((props, ref) => {
  if (props.isPanel) {
    return (
      <Box height="100%" data-testid={props['data-testid']}>
        <VStack height="100%">
          <Box flexGrow={1} padding={4}>
            <div id={props.externalFilterId} />
          </Box>
          <Show when={ref}>
            <Separator spacing={0} />
            <ArticleFolderTree
              ref={ref}
              isPanel
              data-testid={suffixTestId('articleFolderTree', props)}
            />
          </Show>
        </VStack>
      </Box>
    );
  }

  return (
    <Box width={props.width} data-testid={props['data-testid']}>
      <VStack height="100%">
        <Box flexGrow={1}>
          <div id={props.externalFilterId} />
        </Box>
        <Show when={ref}>
          <Separator />
          <ArticleFolderTree ref={ref} data-testid={suffixTestId('articleFolderTree', props)} />
        </Show>
      </VStack>
    </Box>
  );
});
